export default __webpack_public_path__ + "static/media/bg_important_notice-Responsive.3e58301f.webp";